// Single source of truth for the Privacy Policy version + effective date.
// Mirrors backend constants in server.py (CURRENT_PRIVACY_POLICY_VERSION,
// CURRENT_PRIVACY_POLICY_EFFECTIVE_DATE). Bump both sides when the policy changes.
export const CURRENT_PRIVACY_POLICY_VERSION = 'v1.0';
export const CURRENT_PRIVACY_POLICY_EFFECTIVE_DATE = '11 May 2026';
